import React from 'react';

type Props = {
    option: any

    onClick : {(option:any, e:any):void}
}

export default function MoreMenuCustomOption(props:Props) {

    const onClick = (e:any) => {if (!props.option.disabled) props.onClick(props.option,e)}

    const classes = Classes("option", "with-icon", {
        disabled: props.option.disabled
    })

    return (
        <div className={classes} onClick={onClick}>
            <div className={Classes('ico',props.option.icon)}/>
            <div className="label">{props.option.label}</div>
        </div>
    )

}